"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var transitionForValue = function transitionForValue(_ref) {
  var valueToTransition = _ref.valueToTransition,
      animationDuration = _ref.animationDuration;
  return "".concat(valueToTransition, " ease-in-out ").concat(animationDuration);
};
/**
 * shouldAnimateTransition
 * @param {boolean} shouldAnimate
 * @param {string} animationDuration
 * @param {string} valueToTransition
 * shouldAnimateTransition determines, based on the current props,
 * whether to animate the transition with a transition CSS property.
 */


var getTransition = function getTransition(_ref2) {
  var shouldAnimate = _ref2.shouldAnimate,
      animationDuration = _ref2.animationDuration,
      valueToTransition = _ref2.valueToTransition;

  if (shouldAnimate) {
    var values = Array.isArray(valueToTransition) ? valueToTransition : [valueToTransition];
    return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      transition: ", ";\n    "])), values.map(function (value) {
      return transitionForValue({
        valueToTransition: value,
        animationDuration: animationDuration
      });
    }).join(', '));
  }

  return '';
};

var _default = getTransition;
exports["default"] = _default;